import axios from 'axios'
import store from '@/state/store'

/**
 * Turns structured resource-limit 403s into the add-on paywall modal instead
 * of raw error toasts. The backend sends detail as
 * { message, error_code: 'resource_limit_reached', limit_name, limit }.
 *
 * The detail is normalized back to its message string afterwards so existing
 * handlers that render `error.response.data.detail` keep working unchanged.
 */
export function installLimitPaywallInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const detail = error.response?.data?.detail
      if (
        error.response?.status === 403 &&
        detail &&
        typeof detail === 'object' &&
        detail.error_code === 'resource_limit_reached'
      ) {
        store.dispatch('paywall/show', {
          limitName: detail.limit_name,
          limit: detail.limit,
          message: detail.message,
          // serverMessages i18n convention: the modal renders server.<code>
          // in the active locale, falling back to the English message.
          code: detail.code || null,
          params: detail.params || null,
          // Set for limits that can also be covered by consumable credit
          // packs (e.g. image_enhancement) so the paywall offers them.
          creditType: detail.credit_type || null
        })
        error.response.data.detail = detail.message
      }
      return Promise.reject(error)
    }
  )
}
